import { Flex } from '@radix-ui/themes'
import { formatValue } from './claim-form-utils'
import { FieldRow } from './claim-form-fields'
import { CONTACT_ROWS, getFieldLabel } from './claim-form-constants'

export function ContactFields({ data }: { data: Record<string, unknown> }) {
  return (
    <Flex direction="column" gap="3">
      {CONTACT_ROWS.map(([left, right]) => (
        <div key={left} className="claim-form-two-col">
          <FieldRow label={getFieldLabel(left)} value={formatValue(data[left])} />
          {right ? (
            <FieldRow label={getFieldLabel(right)} value={formatValue(data[right])} />
          ) : (
            <div />
          )}
        </div>
      ))}
    </Flex>
  )
}
